import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@one-thd/sui-atomic-components';
import { DeliveryContentDrawer } from './drawer/DeliveryContentDrawer';
import DeliveryContent from './DeliveryContent';
import './delivery-options.style.scss';
import { track } from '../analytics';
import { dataModel } from './dataModel';

const DeliveryOptions = ({
  storeId, zipCode, itemId, quantity, children, visible, useDrawer, channelDemo, useLoader, useError,
  disableSTH, showTodayOrTomorrow = null, configId
}) => {

  const [linkClicked, setLinkClicked] = useState(visible);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setLinkClicked(true);

    setAnchorEl(event.currentTarget);

    track('click', {
      origin: 'delivery-options',
      eventName: 'shipping options',
      primaryCategory: 'tooltip'
    });
  };

  const DeliveryOptionsComponent = () => {
    if (useDrawer) {
      return (
        <>
          <button
            type="button"
            data-automation-id="deliveryDetailsbtn"
            className="u__default-link"
            onClick={handleOnClick}
          >
            {children}
          </button>
          <DeliveryContentDrawer
            zipCode={zipCode}
            storeId={storeId}
            itemId={itemId}
            quantity={quantity}
            isQuickViewOpen={linkClicked}
            setIsQuickViewOpen={setLinkClicked}
            channelDemo={channelDemo}
            useLoader={useLoader}
            useError={useError}
            showTodayOrTomorrow={showTodayOrTomorrow}
            disableSTH={disableSTH}
            configId={configId}
          />
        </>
      );
    }

    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
      <div>
        <Popover
          id="123"
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          title="Delivery Options"
        >
          {linkClicked ? (
            <DeliveryContent
              zipCode={zipCode}
              storeId={storeId}
              itemId={itemId}
              quantity={quantity}
            />
          ) : ('')}
        </Popover>
        <button
          type="button"
          data-testid="get-deliveryOptions"
          // eslint-disable-next-line tailwindcss/no-custom-classname
          className="u__default-link"
          onClick={handleOnClick}
        >
          {children}
        </button>
      </div>
    );
  };

  return (
    <div id="delivery-options-fulfillment-drawer" data-component="DeliveryOptions">
      <DeliveryOptionsComponent />
    </div>
  );
};

DeliveryOptions.displayName = 'DeliveryOptions';

DeliveryOptions.propTypes = {
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string,
  zipCode: PropTypes.string,
  children: PropTypes.node,
  visible: PropTypes.bool,
  quantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  useDrawer: PropTypes.bool,
  channelDemo: PropTypes.string,
  useLoader: PropTypes.bool,
  useError: PropTypes.bool,
  showTodayOrTomorrow: PropTypes.func,
  disableSTH: PropTypes.bool,
  configId: PropTypes.string,
};

DeliveryOptions.defaultProps = {
  children: 'Delivery Options',
  storeId: '',
  zipCode: '',
  quantity: 1,
  visible: false,
  useDrawer: false,
  channelDemo: null,
  useLoader: false,
  useError: false,
  showTodayOrTomorrow: null,
  disableSTH: false,
  configId: null,
};

DeliveryOptions.dataModel = dataModel;

export default DeliveryOptions;
